import { ModelType } from '@/enums/model-type.enum';

export const MODEL_ERROR_MESSAGE_OVERRIDE: Record<string, Record<string, string>> = {
  [ModelType.Kling]: {
    'Invalid reference index 1 for element. Only 0 elements provided.':
      'Elements are not supported for Kling 3 text-to-video',
  },
};
